import { LegalLayout } from "@/components/LegalLayout";
import { LegalSections } from "@/components/LegalSections";
import { DataSafetyTable } from "@/components/DataSafetyTable";
import privacy from "@/content/privacy.mjs";

export default function Privacy() {
  return (
    <LegalLayout
      title={privacy.title}
      eyebrow={privacy.eyebrow}
      updated={privacy.updated}
      toc={privacy.sections}
      testId="privacy-page-container"
      backTestId="privacy-back-home-button"
    >
      <LegalSections sections={privacy.sections} after={{ "information-we-collect": <DataSafetyTable /> }} />
    </LegalLayout>
  );
}
